import { useEffect, useRef } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

import { useAuth } from '../context/AuthContext';


function buildRedirectUri(tenant, location) {
    const origin = window.location.origin;
    const path = `${location.pathname}${location.search || ''}${location.hash || ''}`;

    if (tenant && path.startsWith(`/${tenant}`)) {
        return `${origin}${path}`;
    }

    return tenant ? `${origin}/${tenant}` : origin;
}


export default function RequireTenantAuth() {
    const { authenticated, login } = useAuth();
    const location = useLocation();
    const { tenant } = useParams();
    const startedLoginRef = useRef(false);

    useEffect(() => {
        if (!authenticated && !startedLoginRef.current) {
            startedLoginRef.current = true;
            void login({ redirectUri: buildRedirectUri(tenant, location) });
        }
    }, [authenticated, location, login, tenant]);

    if (!authenticated) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ height: '100vh' }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return <Outlet />;
}